import React from 'react';
import StudentsTestimonial from 'views/StudentsTestimonial';

const StudentsTestimonialpage = () => {
  return <StudentsTestimonial />;
};

export default StudentsTestimonialpage;